import { render, staticRenderFns } from "./FontAwesomeIcon.vue?vue&type=template&id=72c44e5d&"
import script from "./FontAwesomeIcon.vue?vue&type=script&lang=js&"
export * from "./FontAwesomeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports